/**
 * Stores & Tabs Section - Tab Switching
 * Handles city tab navigation and panel visibility
 */

document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.stores-tabs-section');

  sections.forEach(function(section) {
    initializeTabSection(section);
  });
});

function initializeTabSection(section) {
  const tabs = section.querySelectorAll('.stores-tabs__tab');
  const panels = section.querySelectorAll('.stores-tabs__panel');

  if (tabs.length === 0 || panels.length === 0) {
    return;
  }

  // Activate first tab by default
  tabs[0].classList.add('active');
  panels[0].classList.add('active');

  // Add click handlers to tabs
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      const cityId = this.getAttribute('data-city-id');

      if (!cityId) {
        return;
      }

      switchTab(section, cityId);
    });
  });
}

function switchTab(section, cityId) {
  const tabs = section.querySelectorAll('.stores-tabs__tab');
  const panels = section.querySelectorAll('.stores-tabs__panel');

  // Remove active class from all tabs
  tabs.forEach(function(tab) {
    tab.classList.remove('active');
  });

  // Remove active class from all panels
  panels.forEach(function(panel) {
    panel.classList.remove('active');
  });

  // Add active class to clicked tab
  const activeTab = section.querySelector('.stores-tabs__tab[data-city-id="' + cityId + '"]');
  if (activeTab) {
    activeTab.classList.add('active');
  }

  // Add active class to matching panel
  const activePanel = section.querySelector('.stores-tabs__panel[data-city-id="' + cityId + '"]');
  if (activePanel) {
    activePanel.classList.add('active');
  }
}
